
export function verificationStatusStyle(){
  return {
    "unverified": {
      'color': '#c2c2c2'
    },
    "pending": {
      'color': '#ffcd07'
    },
    "verified": {
      'color': '#2acccc'
    },
    "failed": {
      'color': '#ee7266'
    },
    "incomplete": {
      'color': '#ee7266'
    },
  }
}
export default verificationStatusStyle;